import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider, OAuthProvider, signInWithPopup, signOut } from "firebase/auth";
import { getToken, initializeAppCheck, ReCaptchaV3Provider } from "firebase/app-check";

const firebaseConfig = {
    apiKey: "AIzaSyABScVYWOQUP7_MMTCKUKWlMmcaRgDhBjs",
    authDomain: "sidebae.net",
    projectId: "scrollbay-ff457",
    storageBucket: "scrollbay-ff457.appspot.com",
    messagingSenderId: "18697278455",
    appId: "1:18697278455:web:d6c879379d184e3baed4f2"
};
const app = initializeApp(firebaseConfig);
const disableRecaptcha = process.env.REACT_APP_DISABLE_RECAPTCHA === "true";
const appCheck = disableRecaptcha ? null : initializeAppCheck(
    app,
    { provider: new ReCaptchaV3Provider("6LewwuUjAAAAAP1t41GWIzPRqY6XXo7LZwa1Tb1i") }
);
const auth = getAuth(app);
const googleProvider = new GoogleAuthProvider();
const microsoftProvider = new OAuthProvider('microsoft.com');

export default class Auth {
    constructor(setUser) {
        auth.onAuthStateChanged((user) => {
            if (user) {
                setUser(user);
                this.user = user;
            } else {
                setUser(false);
                this.user = null;
            }
        });
    }

    getAppToken = () => {
        if (!appCheck) return Promise.resolve(null);
        return getToken(appCheck, false).then((res) => res.token);
    };

    signInWithGoogle = async (setSigningIn, isMicrosoft, message) => {
        setSigningIn(true);
        const provider = isMicrosoft ? microsoftProvider : googleProvider;
        const res = await signInWithPopup(auth, provider);
        const idToken = await res.user.getIdToken();
        const user = res.user;
        fetch("/sign-in",
            {
                method: "POST",
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({ user: user, idToken: idToken })
            })
            .then((res) => {
                if (message && res) {
                    res.json()
                        .then(data => {
                            const firstName = user?.displayName?.split?.(" ")?.[0];
                            message(`Welcome${data.isNew ? " to sidebae" : " back"}${firstName ? `, ${firstName}!` : "!"}`)

                        });
                }
                setSigningIn(false);
            })
            .catch((e) => {
                if (message) message("Error signing in", "error")
            });
    };

    getUserData = async () => {
        // console.log(`fetching user...`);
        const idToken = await auth.currentUser.getIdToken();
        return fetch("/get-user-data",
            {
                method: "POST",
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({ idToken: idToken })
            })
            .then((res) => res.json())
            .catch((e) => {
                throw (e);
            });
    }

    getUserSubscriptions = async () => {
        // console.log(`fetching user...`);
        const idToken = await auth.currentUser.getIdToken();
        return fetch("/get-user-subscriptions",
            {
                method: "POST",
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({ idToken: idToken })
            })
            .then((res) => res.json())
            .catch((e) => {
                throw (e);
            });
    }


    updateUserData = async (data) => {
        // console.log(`fetching update user...`);
        const idToken = await auth.currentUser.getIdToken();
        return fetch("/update-user-data",
            {
                method: "POST",
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({ idToken: idToken, data: data })
            })
            .then((res) => res.json())
            .catch((e) => {
                throw (e);
            });
    }

    updateUserSubscriptions = async (data) => {
        // console.log(`fetching update user...`);
        const idToken = await auth.currentUser.getIdToken();
        return fetch("/update-user-subscription",
            {
                method: "POST",
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({ idToken: idToken, data: data })
            })
            .then((res) => res.json())
            .catch((e) => {
                throw (e);
            });
    }

    appendUserArray = async (data) => {
        // console.log(`fetching update user array...`);
        const idToken = await auth.currentUser.getIdToken();
        return fetch("/append-user-data-array",
            {
                method: "POST",
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({ idToken: idToken, data: data })
            })
            .then((res) => res.json())
            .catch((e) => {
                throw (e);
            });
    }


    logout = () => {
        signOut(auth);
    };
}
